export default "__VITE_ASSET__6c050438__"